<template>
  <div class="Page inner">
    <div class="innerPageHead">
      <div class="innerPageBanner vagetable">
        <b-container>
          <b-row
            align-h="center"
            align-v="center"
            cols="2"
          >
            <b-col class="text-center">
              <div
                class="innerPageBannerPic pt-md-5 px-md-5 pb-md-3 pt-5 px-4 pb-2"
              >
                <b-img
                  :src="require('@/assets/imgs/icon_interpage_vagetable.png')"
                  fluid
                  alt="蔬果與其他業者"
                ></b-img>
              </div>
              <h2 class="innerPageBannerTitle">蔬果與其他業者</h2>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-container>
        <b-breadcrumb :items="items"></b-breadcrumb>
      </b-container>
    </div>

    <section class="shopIntro">
      <b-container>
        <b-row align-h="center" align-v="center">
          <b-col lg="8">
            <div class="shopIntroText">
              <p>
                魚池鄉位於南投縣的中間地帶，海拔最高2110公尺，最低421公尺，年平均溫度攝氏20度，全年溫暖濕潤，適合中海拔農作物栽培，主要作物有：絲瓜、敏豆、胡瓜、茄子、筊白筍等夏季蔬菜，以及香菇、花卉、檳榔等經濟作物。魚池鄉農會積極推動農業轉型，倡導各級農會以策略聯盟方式，增進彼此間資源和技術的互補。此外，亦全力倡導農村產業文化活動，改善農村生活步調及觀念，並以「生產、生活、生態」互補做法發展休閒農業，促進社區繁榮發展。
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <div class="shopListGroup">
      <b-container>
        <b-row cols="2" cols-sm="2" cols-md="3" cols-lg="4">
          <b-col
            class="shopListItem"
            v-for="item in storeList"
            :key="item.SO_ID"
          >
            <b-link :to="'Shopinfo?id=' + item.SO_ID" class="drop-shadow">
              <div class="shopListPic">
                <b-img :src="item.MainImgUrl" fluid :alt="item.ME_NAME"></b-img>
              </div>
              <div class="shopListTitle">
                <h3>{{ item.SO_NAME }}</h3>
              </div>
            </b-link>
          </b-col>
        </b-row>
        <div class="page">
          <b-pagination
            class="pagination light-theme simple-pagination"
            v-model="pagination.page"
            :total-rows="pagination.rows"
            :per-page="pagination.perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </b-container>
    </div>

    <ul id="myMenu">
      <li>
        <a href="/" tooltip="首頁" flow="left"
          ><span class="icon-home3" title="返回 魚池農易GO 首頁"></span
          ><span class="sr-only">首頁</span>
        </a>
      </li>

      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          class="BackToTop"
          title="回到最頂[連結]"
          ><span class="icon-top"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        navigationActive: [],
        items: [
          {
            text: "首頁",
            href: "#/",
          },
          {
            text: "蔬果與其他業者",
            active: true,
          },
        ],
        storeListAll: [],
        storeList: [],
        pagination: {
          perPage: 8,
          page: 1,
          rows: 5,
        },
        apiStore: (data) => this.userRequest.post("Default/Store", data),
      };
    },
    mounted() {
      this.init();
    },
    watch: {
      "pagination.page"() {
        this.loading = true;
        this.setPage();
      },
    },
    methods: {
      init() {
        let json = {
          TYPE: "FRONT_LIST",
          STORE_SELECT: {
            pageIndex: this.pagination.page,
            pageSize: this.pagination.perPage,
            variety: {
              BlackTea: false,
              Coffee: false,
              Orchid: false,
              Mushroom: false,
              Fruits: true,
            },
          },
        };
        this.FunctionToken(this.APIGetStoreList, json);
      },
      setPage() {
        this.storeList = [];
        let count = this.pagination.perPage * this.pagination.page;
        let count1 = count - this.pagination.perPage;
        this.storeList = this.storeListAll.slice(count1, count);
        this.loading = false;
      },
      // api
      APIGetStoreList(data) {
        this.apiStore(data)
          .then((res) => {
            let json = JSON.parse(res.data);
            if (json.Status) {
              let jsonData = JSON.parse(json.Data);
              console.log(jsonData);
              this.storeListAll = jsonData.outData;
              this.storeList = [];
              this.pagination.rows = jsonData.totalCount;
              this.setPage();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
  };
</script>
